import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useGetFactoriesQuery } from '@api/queries/factory';
import { useCountDownBoostsTimers } from '@common/hooks/count-down-boosts-timers';
import PageBody from '@components/Materials/PageBody/PageBody';
import { PageBackground } from '@components/ui/Backgrounds/PageBackground/PageBackground';
import { boostFactoryTimersEnd } from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

import { useExtendedInfoQuery } from '@/api/queries/user';
import { BACKGROUNDS_CONFIG } from '@/common/config/media-config';

const Materials: React.FC = () => {
  useExtendedInfoQuery();
  useGetFactoriesQuery(undefined, { refetchOnMountOrArgChange: true });
  const factories = useAppSelector((state) => state.factory.list);
  const isTimersEnd = useAppSelector(boostFactoryTimersEnd);
  useCountDownBoostsTimers(!isTimersEnd, 'Factory');

  if (!factories) {
    return null;
  }

  return (
    <main className="w-full h-full flex flex-col justify-end !mb-0">
      <Helmet>
        <title>Materials</title>
      </Helmet>
      <div className="w-full flex-1 overflow-hidden relative">
        <PageBackground
          className="h-full absolute left-0 bottom-0 min-h-[300px]"
          variant="page"
          backgroundImage={{
            png: BACKGROUNDS_CONFIG.BG_MATERIAL.png,
            webp: BACKGROUNDS_CONFIG.BG_MATERIAL.webp,
          }}
        />
      </div>
      <div className="tabs tabs--sticky">
        <PageBody />
      </div>
    </main>
  );
};

export default Materials;
